// extracted by mini-css-extract-plugin
module.exports = {"scrollBtnWrap":"_27TUQ","scrollBtn":"_3czFJ"};